export const DESKTOP_HEADER_HEIGHT = "72px"
export const MOBILE_HEADER_HEIGHT = "64px"

export default {
  DESKTOP_HEADER_HEIGHT,
  MOBILE_HEADER_HEIGHT,
}
